import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Protected from "../Protected";
import { getToken, getLoggedInUser } from "../../utils/storageUtils";
import { canAccessRoute } from "../../constants/roles";

/**
 * Écran de repli d'un rôle qui n'a pas le droit d'ouvrir la route demandée.
 * La liste des patients est accessible à tous les profils du personnel.
 */
const FORBIDDEN_ROUTE_FALLBACK = "/patient";

/**
 * Garde de route par rôle. Vérifie d'abord l'authentification (déléguée à
 * {@link Protected}), puis applique la liste blanche
 * {@code STAFF_ROUTES_BY_ROLE} de {@code constants/roles} au chemin courant :
 * un rôle qui n'a pas cet écran dans sa liste est redirigé vers
 * {@code /patient}.
 *
 * Le chemin est lu depuis l'URL courante plutôt que passé en prop, pour qu'il
 * ne puisse pas diverger du {@code path} déclaré dans {@code Routes.js}.
 * L'utilisateur est lu au rendu (jamais au chargement du module) afin de
 * rester juste après un changement de session.
 *
 * @example
 *   <RoleProtected>
 *     <Users />
 *   </RoleProtected>
 */
const RoleProtected = ({ children }) => {
  const { pathname } = useLocation();
  const isRouteAllowed = canAccessRoute(getLoggedInUser(), pathname);

  return (
    <Protected isSignedIn={!!getToken()}>
      {isRouteAllowed ? (
        children
      ) : (
        <Navigate to={FORBIDDEN_ROUTE_FALLBACK} replace />
      )}
    </Protected>
  );
};

export default RoleProtected;
